import { createStore } from 'vuex';
import content from '@/store/content';
import favoriteItems from '@/store/favorite-items';
import favoriteOrders from '@/store/favorite-orders';
import giftCards from '@/store/gift-cards';
import hotels from '@/store/hotels';
import locale from '@/store/locale';
import locations from '@/store/locations';
import menu from '@/store/menu';
import merchant from '@/store/merchant';
import modals from '@/store/modals';
import offers from '@/store/offers';
import orderHistory from '@/store/order-history';
import orders from '@/store/orders';
import receipt from '@/store/receipt';
import savedCards from '@/store/saved-cards';
import session from '@/store/session';
import shipping from '@/store/shipping';
import socket from '@/store/socket';

import { orderAhead } from './order-ahead';
import { orderAtTable } from './order-at-table';


const store = createStore({
  // NOTE: Vuex 4.1.0 strict mode is incompatible with Vue 3.5's reactivity batching system.
  // The deep watcher fires after _committing is reset, producing false positives on valid mutations.
  // Vuex 4 is in maintenance mode (Pinia is the successor) so this won't be patched upstream.
  strict: false,
  modules: {
    content,
    favoriteItems,
    favoriteOrders,
    giftCards,
    hotels,
    locale,
    locations,
    menu,
    merchant,
    modals,
    offers,
    orderHistory,
    orders,
    receipt,
    savedCards,
    session,
    shipping,
    socket,
    orderAhead,
    orderAtTable
  }
});

export default store;
